import { type DispatcherEvent } from '@carvana/merch-native';
import { type PurchaseEventPayload } from '~/native/common/contracts';
import { sendMessageToNative } from '~/native/vdp/dispatchers';

export default function sendPurchaseMessageToNative(
  event:
    | DispatcherEvent.ContinuePurchase
    | DispatcherEvent.StartPreOrder
    | DispatcherEvent.StartPurchase,
  payload: PurchaseEventPayload,
  callback?: () => void
) {
  sendMessageToNative(event, payload, { callback });
}
